import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { ChangeEvent, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import MarkdownEnabledTextfield from './MarkdownEnabledTextfield'
import SaveCancel from './SaveCancel'
import { markdownWhitelistMessages } from './Message'
import { useStore } from '../../contexts/store'

const TextArea = (
  props: {
    handleClose: () => void
    placeholder: string,
    showHints: boolean,
    submit: (input: string) => void,
    value: string,
    disabled: boolean,
    context: string,
  }) => {

  const { handleClose, placeholder, showHints, submit, value, disabled, context } = props
  const { uiStore } = useStore()
  const { t } = useTranslation()
  //const [input, setInput] = useState("")
  const [input, setInput] = uiStore.useUiState(context, "")

  useEffect(() => {
    // if a value was given, pass it to the input field
    if(value) {
      setInput(value)
    }
  }, [value])

  function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
    setInput(e.target.value)
  }

  function doSubmit() {
    if(input !== "") {
      submit(input)
      setInput("")
    }
  }

  return (
    <Box sx={{display: "grid", gridTemplateColumns: "auto", gridTemplateRows: "min-content min-content auto",  alignItems: "end"}}>
      <Box sx={{ display: "grid", margin: "5px 10px 0 10px" }}>
        <MarkdownEnabledTextfield
          handleInputChange={handleInputChange}
          handleClose={handleClose}
          placeholder={placeholder}
          minRows={showHints ? 1 : 3}
          submit={doSubmit}
          value={input}
          disabled={disabled}
          style={{maxHeight:440}}
          whitelist={markdownWhitelistMessages}
          helperText={t(`Press Ctrl+Enter to save.`)||''}
        />
      </Box>
        <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "10px",
          }}
        >
      </Box>
      <SaveCancel handleSave={doSubmit} handleClose={handleClose} />
    </Box>
  )
}

export default observer(TextArea)